// app/javascript/controllers/profiles/show_controller.js
import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue'
import ProfilePage from '~/javascript/components/profile/index.vue'

export default class extends Controller {
  connect() {
    const app = createApp(ProfilePage)
    app.mount(this.element)
  }

  disconnect() {
    // Clean up if needed
  }
}
